import { Formik, getIn } from "formik";
import { FC, useState } from "react";


import { CreateMyAirdropWalletFormValues, createMyAirdropWalletFormValidationSchema, createMyAirdropWalletFormValuesInitialValue } from ".";
import { Box, Card, CardContent, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { useAddWalletMutation } from "../../../../store/models/users";
import { successNotificationFromPromise } from "../../../../store/notifications/utils";
import { processErrorFromPromise } from "../../../../store/errors/utils";
import { H2 } from "../../../../components/typography";
import { PrimaryButton } from "../../../../components/button";
import { WalletsActions } from "../../../../store/wallets/actions";
import { useDispatch } from "react-redux";


interface CreateMyAirdropWalletFormProps {
    userId: string;
}
export const MyAirdropWalletForm: FC<CreateMyAirdropWalletFormProps> = ({ userId }) => {
    // const login = useSelector<AppStore, Fetchable<AuthDTO.Responses.Login.T>>(
    //     (store) => store.auth.login
    // );
    // if (login.status !== "ready")
    //   return Promise.reject(new Error("User not logged in"));

    // return api
    //   .get(
    //     `v1/users/${login.data.accessToken.credentialsId}/wallets/${address}/nonce`
    // const { data: history } = useDocumentsHistoryQuery(
    //     { latest: true },
    //     { refetchOnMountOrArgChange: true }
    // );

    // const [dataHistory, setDataHistory] = useState<KycTypedFile[]>([]);

    // useEffect(() => {

    //     if (history) {
    //         let result: KycTypedFile[] = [];
    //         for (const [key, value] of Object.entries(history.documents) as any) {
    //             let subResult = value.map((v: KycFile) => ({ type: key, ...v }))
    //             result = [...result, ...subResult]
    //         }
    //         setDataHistory(result);
    //     }

    // }, [history]);
    const dispatch = useDispatch();
    const [addWallet] = useAddWalletMutation();
    // const { t } = useTranslation();
    const [disableButton, setDisableButton] = useState<boolean>(false);
    return (
        <Formik<CreateMyAirdropWalletFormValues>
            enableReinitialize
            initialValues={{
                ...createMyAirdropWalletFormValuesInitialValue(),
            }}
            validationSchema={createMyAirdropWalletFormValidationSchema(
            )}
            onSubmit={async (values, { resetForm }): Promise<void> => {
                try {
                    setDisableButton(true);

                    addWallet({ address: values.address!, chain: values.chain, userId: userId })
                        .unwrap()
                        .then(
                            successNotificationFromPromise('Address added successfully'),
                        )
                        .then(() => {
                            resetForm();
                            dispatch(WalletsActions.resetWallets());
                        }
                        )
                        .catch(processErrorFromPromise
                        ).finally(() => {
                            setDisableButton(false);
                        })


                } catch (err) {
                    console.log(err);
                }
            }}
        >
            {({
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                values,
                setFieldValue,
                errors,
                touched,
            }): JSX.Element => (
                <>
                    {/* <pre>{JSON.stringify(history, null, 2)}</pre> */}
                    {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
                    {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                    {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}

                    <Box sx={{}}>
                        <form noValidate onSubmit={handleSubmit}>




                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <small>
                                        <H2> Kindly add all Solana wallets you want to associate with your account. These wallets <strong>SHOULD NOT</strong> be wallets held at an exchange. any promotional activities by Sekuritance and its partners that involve airdrops or bonus project tokens will be delivered to one of these addresses</H2>
                                    </small>
                                </Grid>


                                <Grid item xs={12} sm={6} lg={4} style={{ alignItems: 'center', display: 'flex' }}>
                                    <Typography variant="body2">Solana Wallet Address</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} lg={8}>
                                    <FormControl fullWidth margin='dense'>
                                        <TextField name={'address'} variant="outlined" value={getIn(values, 'address')} onBlur={handleBlur} onChange={handleChange}
                                            error={Boolean(getIn(touched, 'address') && !!getIn(errors, 'address'))}
                                            helperText={getIn(touched, 'address') && getIn(errors, 'address')} />
                                    </FormControl>
                                </Grid>

                            </Grid>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <PrimaryButton
                                    disabled={disableButton}
                                    type="submit">Add wallet</PrimaryButton>
                            </Box>

                        </form>
                    </Box>

                </>
            )}
        </Formik>
    );
};